import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthguardGuard } from '../guard/authguard.guard';
import { service_methods6 } from '../admin/service_methods6';
import { DashboardcommonComponent } from '../dashboardcommon/dashboardcommon.component';

declare let $: any;
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  constructor(
    private ref: ChangeDetectorRef,
     private obj: service_methods6, private msg: ToastrService, private router: Router, private activaterouter: ActivatedRoute, private authservice: AuthguardGuard) {
    activaterouter.params.subscribe(val => {
      this.bindmenus();
    })
  }
  
  arr_menus = []
  arr_menustop = []
  ngOnInit(): void {
  }

  GetClick() {
    $.getScript("assets/js/on-canvas.js");
    $.getScript("assets/js/sidebar.js");
  }

  selectOnlyThis(id,parentid) {
    for (var i = 2; i <= this.arr_menus.length; i++) {
      var chk = document.getElementById("check" + i) as HTMLInputElement;
      var chkparent = document.getElementById("check"+parentid) as HTMLInputElement;
      if(chkparent){
        chkparent.checked = true;
      }
      if (chk) {
        if (i === id && chk.checked === true) {
          chk.checked = true;
          if (chkparent) {
            chkparent.checked = true;
          }
        } else {
          chk.checked = false;
          if (chkparent) {
            chkparent.checked = true;
          }
        }
      }
    }
  }
  filtermenus(menuid) {
    return this.arr_menus.filter((item) => item.parentmenuid == menuid)
  }
  childitemcount(menuid): number {
    return this.arr_menus.filter((item) => item.parentmenuid == menuid).length;
  }

  async bindmenus() {
    await this.obj._commonget("menu_getmenus").then((data) => {
      this.arr_menus = data;
      localStorage.setItem("loginid", JSON.stringify(this.arr_menus.map(it => it.routelink)))
      this.delay(3000).then(() => {
        this.ref.detach();
      })
    })
  }
  async delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
